import React, { memo } from 'react';
import { Layout } from 'tea-component';
import Loading from '@gp/components/Loading';
import PageAccess from '@gp/components/PageAccess';
import { context as Context } from '@gp/components/Context';
import { DESCRIPTION_C } from '@gp/constants/noPermissionTips';
import './index.scss';

const { Content } = Layout;

interface StudioReport {
  loading: boolean;
  title: JSX.Element | string;
  subTitle?: JSX.Element | string;
  children: JSX.Element | (any & {});
}

const DEFAULT_PROPS: StudioReport = {
  loading: true,
  title: '',
  children: null,
  subTitle: '',
};

const StudioReport: React.FC<StudioReport> = (props) => {
  const { loading, title, subTitle } = props;

  return (
    <PageAccess isAccess={true} description={DESCRIPTION_C}>
      <>
        <Context.Provider value={{}}>
          <Content className="dbg-studio-monthly-report dbg-page-scroll">
            <Content.Header
              className="dbg-studio-monthly-report-header dbg-header"
              title={title || '-'}
            >
              {subTitle ? <div className="header-des">{subTitle}</div> : null}
            </Content.Header>
            <Content.Body full className="dbg-studio-monthly-report-body">
              {loading && (
                <Loading
                  style={{ position: 'unset' }}
                  loading
                  loadingBg="#f2f3f5"
                />
              )}
              {!loading && props?.children}
            </Content.Body>
          </Content>
        </Context.Provider>
      </>
    </PageAccess>
  );
};

StudioReport.defaultProps = DEFAULT_PROPS;

export default memo(StudioReport);
